import { CommentRepliesOptions, CommentRepliesResponse } from './types';
import { makeRequest } from '../makeRequest';

export async function getCommentReplies(
   commentid: number,
   { limit, offset, ...common }: CommentRepliesOptions = {}
): Promise<CommentRepliesResponse> {
   return makeRequest('get', `comments/${commentid}/replies`, {
      ...common,
      query: {
         limit,
         offset,
      },
   });
}
